export type GuestCountOption = {
	/** 大人人数（1始まり） */
	value: number;
	label: string;
};

const DEFAULT_MAX_ADULT = 2;

/**
 * rateMatrix.maxAdultNum から「大人N名」の人数フィルタ選択肢を作る。
 * 子供込みパターンは対象外。定員外セルは API が not_applicable を返す。
 */
export const buildGuestCountOptions = (maxAdultNum: number): GuestCountOption[] => {
	const maxAdult = Math.max(1, Number.isFinite(maxAdultNum) && maxAdultNum > 0 ? maxAdultNum : DEFAULT_MAX_ADULT);

	return Array.from({ length: maxAdult }, (_, index) => {
		const adultNum = index + 1;
		return {
			value: adultNum,
			label: `大人${adultNum}名`,
		};
	});
};

/** 選択肢に含まれる既定人数（2名優先、なければ最大） */
export const getDefaultGuestAdultNum = (options: GuestCountOption[]): number => {
	if (options.some((option) => option.value === 2)) {
		return 2;
	}
	return options[options.length - 1]?.value ?? 1;
};
